import {gql} from '@apollo/client';

export const MUTATION_CREATE_ANKET = gql`
mutation createAnket($data: AnketInput!) {
    createAnket(data: $data) {
        documentId
    }
}`

export const QUERY_ANKETS = gql`
    query ankets($filters: AnketFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []) {
        ankets(filters: $filters,pagination: $pagination, sort: $sort) {
            documentId
            identifier
            value
            createdAt
        }
    }`

export const QUERY_STEP = gql`
    query step {
        step {
            step
        }
    }`